import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { fetchCostCenter } from "../../api/costCenters";
import type { PriceReportSelection } from "../../api/priceReport";
import { displayCostCenterTitle, costCenterTypeLabel } from "../../lib/costCenterDisplay";

export default function CostCenterReportContext({ selection, busy }: { selection: PriceReportSelection; busy: boolean }) {
  const query = useQuery({
    queryKey: ["cost-center", selection.costCenter, selection.costCenterType],
    queryFn: () => fetchCostCenter(selection.costCenter!, selection.costCenterType),
    enabled: !!selection.costCenter,
  });
  if (!selection.costCenter) return null;
  const entity = query.data;
  const title = entity ? displayCostCenterTitle(entity.cost_center_type, entity.cost_center_key, entity.display_label, { manualLabel: entity.manual_display_label, customerAnchorLabel: entity.customer_anchor_label }) : null;
  return <section aria-label="Ausgewählte Kostenstelle" className="mb-6 border-b border-slate-200 pb-4">
    {selection.returnTo && !busy && <Link className="text-sm text-emerald-800 hover:underline" to={selection.returnTo}>← Zurück zur Kostenstelle</Link>}
    <p className="mt-3 font-semibold">{query.isPending ? "Kostenstelle wird geladen …" : title ?? "Kostenstelle aus dem Ausgangslink"}{entity ? ` · ${costCenterTypeLabel(entity.cost_center_type)}` : ""}</p>
    {query.isError && <p role="status" className="mt-1 text-sm text-slate-600">Die Bezeichnung konnte nicht geladen werden. Der Bericht bleibt auf die Kostenstelle aus dem Link begrenzt.</p>}
    <p className="mt-2 text-sm text-slate-600">Prüfe die Rechnungspreise dieser Kostenstelle. Gutschriften sind hier nicht enthalten. Verglichen wird mit früheren Einkäufen desselben Artikels, auch außerhalb dieser Kostenstelle.</p>
  </section>;
}
